import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import moment from 'moment';
import { viewUser } from '../../../../services/user';
import { rateUser, deleteRating } from '../../../../services/rating';
import {
  Card,
  Avatar,
  Tooltip,
  Button,
  message,
  Comment,
  Empty,
  Popconfirm,
} from 'antd';
import { DislikeFilled, LikeFilled } from '@ant-design/icons';
import UnifiedDashboard from '../../../../components/layout/unified-dashboard';

const { Meta } = Card;

const RateUser = ({ match, children }) => {
  const [values, setValues] = useState({
    _id: '',
    name: '',
    username: '',
    phone: '',
    photo: '',
    ratings: [],
  });

  const [active, setActive] = useState({
    thumbsUp: false,
    thumbsDown: false,
  });
  //   all ratinsg state
  const [rating, setRating] = useState('');
  const [rated, setRated] = useState('');
  const [feedback, setFeedback] = useState('');
  const [positiveRatings, setpositiveRatings] = useState([]);
  const [negativeRatings, setnegativeRatings] = useState([]);
  const [isUser, setIsUser] = useState(false);

  const { thumbsUp, thumbsDown } = active;
  const { _id, name, username, phone, photo, ratings } = values;

  const { user } = isAuthenticated();

  //antd ratings list start
  // const [action, setAction] = useState(null);

  // const comment = () => {};
  //ratings list end
  const positiveRating = [];
  const negativeRating = [];

  //   load user and also get user ratings info
  const loadUser = async () => {
    let res = await viewUser(match.params.userId);
    console.log(res);
    res.data.ratings.forEach((item) => {
      if (item.rating === 'positive') {
        positiveRating.push(item._id);
        setpositiveRatings(positiveRating);
      } else if (item.rating === 'negative') {
        negativeRating.push(item._id);
        setnegativeRatings(negativeRating);
      }
      if (item.author._id === user._id) {
        setRated(item.author._id);
      }
    });
    if (res.data._id === user._id) {
      setIsUser(true);
    }
    setValues({
      ...values,
      ...res.data,
    });
  };

  useEffect(() => {
    loadUser();
  }, []);

  const handlePositive = () => {
    setActive({ thumbsUp: true, thumbsDown: false });
    setRating('positive');
  };
  const handleNegative = () => {
    setActive({ thumbsDown: true, thumbsUp: false });
    setRating('negative');
  };

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(user);

    try {
      const res = await rateUser(match.params.userId, {
        rating: rating,
        feedback: feedback,
        author: user._id,
      });
      console.log(res);
      message.success('Thanks for rating this user', 4);
      history.push(`/user/${_id}`);
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) message.error(err.response.data, 4);
    }
  };

  const handleChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleRatingDelete = async (ratingId) => {
    const res = await deleteRating(ratingId, { userId: match.params.userId });
    if (res) {
      console.log(res);
      history.push(`/user/${_id}`);
      message.success('Rating Deleted', 4);
    }
  };

  const rateUserForm = () => (
    <form onSubmit={handleSubmit}>
      <div className='rate-user-container'>
        <Button
          type={thumbsUp ? 'primary' : 'default'}
          icon={<LikeFilled />}
          onClick={handlePositive}
          className='rate-user-stat-label'
        >
          Positivo
        </Button>
        <Button
          type={thumbsDown ? 'primary' : 'default'}
          icon={<DislikeFilled />}
          onClick={handleNegative}
          className='rate-user-stat-label'
        >
          Negativo
        </Button>
      </div>
      <div className='form-group mb-4'>
        <label className='form-label'>Comentário (opcional)</label>
        <textarea
          className='form-control shadow-none rounded-3'
          placeholder='Deixe um feedback para este usuário'
          value={feedback}
          onChange={handleChange}
          rows={3}
        />
      </div>
      <div className='rate-user-center'>
        <Button
          type='primary'
          size='large'
          shape='round'
          htmlType='submit'
          className='rate-user-rating-btn'
          disabled={!rating}
        >
          Enviar Avaliação
        </Button>
      </div>
    </form>
  );

  return (
    <UnifiedDashboard>
      <div className='rate-user-content'>
        <div className='rate-user-card card rounded-3 card-shadow'>
          <div className='card-header p-4 bg-white border-bottom-0'>
            <h2 className='text-center mb-0'>Avaliar Usuário</h2>
          </div>
          <div className='card-body'>{rateUserForm()}</div>
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default RateUser;
